import { colors } from '@/theme/variables';

export type InspectionStatus = 'Pending' | 'Failed' | 'In Progress' | 'Passed';

export const inspectionsStatusColor = {
  Pending: colors.primary.main,
  Failed: colors.error.main,
  'In Progress': colors.warning.main,
  Passed: colors.secondary.main,
};

export const complaintTypes = [
  'Complaint',
  'Courtesy',
  'Daycare / Private School',
  'Fire Drill',
  'Health Care Facility Annual Licensing',
  'Home (Foster and Adoption)',
  'Maintenance',
  'New Tenant',
  'System Impairment',
] as const;
export type InspectionType = (typeof complaintTypes)[number];
export interface BuildingRecord {
  _id: string;
  type: string; // always "Building"
  name: string;
  streetAddress: string;
  city: string;
  zipCode: string;
}

export interface BuildingInspection {
  _id: string;
  building_id: string;
  type: InspectionType; // e.g. "Complaint"
  scope: string;
  assignedTo: string;
  requestedDate: string; // "YYYY-MM-DD"
  status: InspectionStatus;
}

export const feePaymentMethods = ['Check', 'Certified Payments'] as const;
export type FeePaymentMethod = (typeof feePaymentMethods)[number];

export interface IFee {
  _id: string;
  inspection_id: string;
  fee: number;
  paymentMethod: FeePaymentMethod;
  checkNumber?: string;
  receiptNumber?: string;
  feeExplanation?: string;
  datePayed: string;
  note?: string;
}

export type IVisitNote = {
  _id: string;
  inspection_id: string;
  note: string;
  photoUrl: string;
};
export type IViolation = {
  _id: string;
  inspection_id: string;
  issue: string;
  location: string;
  codeReference: string;
  photoUrl: string;
  issueDate: string;
  isCorrected?: boolean;
};

export type IVisit = {
  _id: string;
  assignedTo: string;
  scheduledDateTime: string;
  includePhotosInReport: boolean;
  backdateInspection: boolean;
  status: 'Passed' | 'Failed';
  name: string;
  title: string;
  businessName: string;
  businessPhone: string;
  cellPhone: string;
  emailAddress: string;
  additionalEmails: string[];
  reinspectionDays?: number;
  inspectionFee?: number;
  signatureNote?: string;
  violation_ids: string[];
  note_ids: string[];
  inspection_id: string;
};
